import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  // change password
  updatePassword({ commit }, { UserID, CurrentPassword, NewPassword } = {}) {
    var changePasswordData = new FormData()
    changePasswordData.append('UserID', UserID)
    changePasswordData.append('CurrentPassword', CurrentPassword)
    changePasswordData.append('NewPassword', NewPassword)

    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.changepassword}`,
        changePasswordData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },
  fetchResetTokenIsValid({ commit }, { token }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.validateresetpasswordtoken}/${token}`,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  resetNewPassword({ commit }, { currentPassword, tokenId, newPassword }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    var resetData = JSON.stringify({
      currentPassword: currentPassword,
      tokenId: tokenId,
      newPassword: newPassword,
    })

    return axios.post(
      `${appConfig.apiEndPoint}${endpoint.identityApiPath.resetNewPassword}`,
      resetData,
      {
        headers: headers,
      }
    )
  },

  activateUserAccount(
    { commit },
    { userName, password, tokenId, userAccountActivationQuestionViewModels }
  ) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    var activationdata = JSON.stringify({
      userName: userName,
      Password: password,
      TokenId: tokenId,
      userAccountActivationQuestionViewModels: userAccountActivationQuestionViewModels,
    })
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.useraccountactivation}`,
        activationdata,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // Check User Name Exists or Not
  isUserNameExists({ commit }, { username } = {}) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.isusernameexists}/${username}`,
        { headers: headers }
      )
      .then((response) => {
        return response.data
      })
  },
  fetchSecurityQuestion({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(`${appConfig.adminApiUri}master/getsecurityquestions`, {
        headers: headers,
      })
      .then(function(response) {
        return response.data
      })
      .catch(function(error) {
        alert(error)
      })
  },
  fetchAccountTokenIsValid({ commit }, { token }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.validateaccountactivationtoken}/${token}`,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  logOut({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    this.state.auth.currentUser = null
    return axios
      .post(`${appConfig.apiEndPoint}${endpoint.identityApiPath.logout}`, {
        headers: headers,
      })
      .then((response) => {})
  },

  validateUser({ state }, { emailAddress, isforgotUserName } = {}) {
    if (isforgotUserName === undefined) {
      isforgotUserName = false
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.validateuser}/${emailAddress}/${isforgotUserName}`
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        if (error.response && error.response.status === 400) {
          return error.response
        }

        return error
      })
  },
  resetPasswordOnLogin({ commit }, { password, tokenID }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    var resetData = JSON.stringify({
      Password: password,
      TokenID: tokenID,
    })

    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.resetpassword}`,
        resetData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  getUserSecurityQuestions({ commit }, { tokenId }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.getSecurityQuestionsForReset}${tokenId}`,
        {
          headers: headers,
        }
      )
      .then(function(response) {
        return response.data
      })
      .catch(function(error) {
        alert(error)
      })
  },

  validateSecurityQuestions({ commit }, { answers }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.validateSecurityQuestions}`,
        answers,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
}
